export default __webpack_public_path__ + "static/media/destroy_button.fcb3a996.svg";